import axios from 'axios';
import querystring from 'qs';
import { AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT, AUTH_REQUEST_IMPERSONATE, AUTH_SUCCESS_IMPERSONATE, AUTH_EXACHANGEUSER, AUTH_ADMINUSER } from '../actions/authactions';
import * as cookie from 'tiny-cookie';

function getJsonCookieValue(cookiename) {
    const rawValue = cookie.get(cookiename);
    if (!rawValue) return null;
    try {
        let parsedValue = JSON.parse(decodeURIComponent(rawValue));
        return parsedValue;
    } catch (err) {
        return null;
    }
}

function setJsonCookieValue(cookiename, value) {
    cookie.set(cookiename, encodeURIComponent(JSON.stringify(value)), Infinity);
}

const USERCOOKIE = 'usersettings';
const USERADMINCOOKIE = 'useradminsettings';
let user = null;
const userCookieValue = getJsonCookieValue(USERCOOKIE);
if (userCookieValue)
    user = userCookieValue;
else
    user = {
        token: null,
        role: null,
        username: null,
        workerid: null
    };
let useradmin = null;
const userAdminCookieValue = getJsonCookieValue(USERADMINCOOKIE);
if (userAdminCookieValue)
    useradmin = userAdminCookieValue;
else
    useradmin = {
        token: null,
        role: null,
        username: null,
        workerid: null
    };
const state = { user: user, testenvironment: true, status: '', useradmin: useradmin };

const getters = {
    isAuthenticated: state => !!state.user.token,
    authStatus: state => state.status,
    user: state => state.user,
    testenvironment: state => state.testenvironment,
    isAdministrator: state => state.user.role === 'Administrator',
    isWorkerAdmin: state => state.user.role === 'WorkerAdmin',
    isWorkerUser: state => state.user.role === 'WorkerUser',
    useradmin: state => state.useradmin,
    

};

const actions = {
    [AUTH_REQUEST]: ({ commit }, user) => {
        return new Promise((resolve, reject) => {
            commit(AUTH_REQUEST);
            axios.post(APIURL + '/connect/token', querystring.stringify({ grant_type: 'password', username: user.username, password: user.password, scope: 'roles', deviceType:0, pushToken:'test' }))
                .then(resp => {
                    commit(AUTH_SUCCESS, resp);
                    resolve(resp);
                })
                .catch(err => {
                    commit(AUTH_ERROR, err);
                    reject(err);
                });
        });
    },
    [AUTH_REQUEST_IMPERSONATE]: ({ commit }, user) => {
        commit(AUTH_ADMINUSER);
        return new Promise((resolve, reject) => {
            commit(AUTH_REQUEST_IMPERSONATE);
            axios.post(APIURL + '/connect/token', querystring.stringify({ grant_type: 'password', username: user.username, password: user.password, scope: 'roles', loginHint: 'impersonate' }))
                .then(resp => {
                    commit(AUTH_SUCCESS_IMPERSONATE, resp);
                    resolve(resp);
                })
                .catch(err => {
                    commit(AUTH_ERROR, err);
                    reject(err);
                });
        });
    },
    [AUTH_LOGOUT]: ({ commit }) => {
        return new Promise((resolve) => {
            console.log(1);
            commit(AUTH_LOGOUT);
            console.log(2);
            resolve();
            console.log(3);
        });
    },
    [AUTH_EXACHANGEUSER]: ({ commit }) => {
        //return this.AUTH_REQUEST_IMPERSONATE({ username: state.useradmin.username, password: state.useradmin.username });       
        commit(AUTH_EXACHANGEUSER);
    }
};

const mutations = {
    [AUTH_REQUEST]: (state) => {
        state.status = 'loading';
    },
    [AUTH_REQUEST_IMPERSONATE]: (state) => {
        state.status = 'loading';
    },
    [AUTH_SUCCESS]: (state, resp) => {
        state.status = 'success';
        state.user.token = resp.data.access_token;
        state.user.role = resp.data.role;
        state.user.username = resp.data.username;
        state.user.workerid = resp.data.workerid;
        //cookie.set(USERCOOKIE, JSON.stringify(state.user), Infinity);
        setJsonCookieValue(USERCOOKIE, state.user);
        // Here set the header of your ajax library to the token value.
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + resp.data.access_token;
        state.testenvironment = resp.data.testenvironment;
    },
    [AUTH_SUCCESS_IMPERSONATE]: (state, resp) => {
        state.status = 'success';
        state.user.token = resp.data.access_token;
        state.user.role = resp.data.role;
        state.user.username = resp.data.username;
        state.user.workerid = resp.data.workerid;
        state.user.loginHint = 'impersonate';
        //cookie.set(USERCOOKIE, JSON.stringify(state.user), Infinity);
        setJsonCookieValue(USERCOOKIE, state.user);
        // Here set the header of your ajax library to the token value.
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + resp.data.access_token;
        state.testenvironment = resp.data.testenvironment;
    },
    [AUTH_ERROR]: (state) => {
        state.status = 'error';
        state.user = {
            token: null,
            role: null,
            username: null,
            workerid:null
        };
        cookie.remove(USERCOOKIE);
    },
    [AUTH_LOGOUT]: (state) => {
        state.user = {
            token: null,
            role: null,
            username: null,
            workerid:null
        };
        state.useradmin = {
            token: null,
            role: null,
            username: null,
            workerid: null
        };
        cookie.remove(USERCOOKIE);
        cookie.remove(USERADMINCOOKIE);
        // remove the axios default header
        delete axios.defaults.headers.common['Authorization'];
    },
    [AUTH_EXACHANGEUSER]: (state) => {
        state.user.username = state.useradmin.username;
        state.user.role = state.useradmin.role;
        state.user.token = state.useradmin.token;
        state.user.workerid = state.useradmin.workerid;
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + state.user.token;
        //cookie.set(USERCOOKIE, JSON.stringify(state.user), Infinity);
        setJsonCookieValue(USERCOOKIE, state.user);
        cookie.remove(USERADMINCOOKIE);
        state.useradmin.username = null;
        state.useradmin.role = null;
        state.useradmin.token = null;
        state.useradmin.workerid = null;

    },
    [AUTH_ADMINUSER]: (state) => {
        //cookie.set(USERADMINCOOKIE, JSON.stringify(state.user), Infinity);
        setJsonCookieValue(USERADMINCOOKIE, state.user);
        state.useradmin.username = state.user.username;
        state.useradmin.role = state.user.role;
        state.useradmin.token = state.user.token;
        state.useradmin.workerid = state.user.workerid;
    }
};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};